<template>
  <div class="search-autocomplete">
    <form :action="action">
      <div class="search">
        <input v-model="query" id="title-search-input" type="text" :name="name" autocomplete="off" required="required"
               class="header-main__search-input" :placeholder="placeholder"/>
        <input :disabled="disabled" name="s" type="submit" value="Поиск" class="btn"/>
      </div>
    </form>
    <div v-if="items.length" class="search-results">
      <div v-for="item in items" class="search-results__item">
        <div class="search-results__item-title">
          <a :href="item.url" v-html="item.title"></a>
        </div>
        <div class="search-results__item-desc" v-html="item.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchAutocomplete",
  props: {
    name: {
      type: String,
      default: 'q',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    query: '',
    searchTimeout: null,
    items: [],
  }),
  mounted() {
    this.query = this.value;
  },
  computed: {
    disabled() {
      return !this.query.replace(/\s/gi,'');
    }
  },
  watch: {
    query(val) {
      this.items = [];
      clearTimeout(this.searchTimeout);
      if (val.length > 3) {
        this.searchTimeout = setTimeout(() => {
          this.load(this.query);
        }, 2000);
      }
    },
  },
  methods: {
    load(query) {
      BX.ajax.runComponentAction('xpage:ajax', 'getSearchItems', {
        mode: 'class',
        data: {
          query,
        },
      }).then(response => {
        if (response.status == 'success') {
          if (response.data && response.data.items) {
            this.items = response.data.items;
          }
        }
      });
    },
  },
}
</script>
